<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 报表管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>生产订单统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="orderno" >
                <el-input v-model="searchform.orderno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据状态" prop="status">
                 <el-select type="text" filterable v-model="searchform.status" style="width:100%">
                  <el-option
                    v-for="(item,index) in status"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产日期" prop="datelist" >
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                           value-format="timestamp"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
             <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['productionorder_select']">搜索</el-button>
              <el-button
              v-permission="['productionorder_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>生产订单统计</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="orderno" label="订单" min-width="120" show-overflow-tooltip></el-table-column>
             <el-table-column prop="batchno" label="批次号" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="factory" label="工厂" width="200" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="qrcode" label="加工厂名称" min-width="150" show-overflow-tooltip></el-table-column> -->
            <el-table-column prop="workshop" label="车间" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workline" label="产线" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productUnit" label="计量单位" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productQuantity" label="计划生产数量" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="collectionQuantity" label="采集上传数量" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="produceTime" label="生产日期" min-width="160" show-overflow-tooltip fixed="right"></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { orderno } from "@/api/report";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数
      status:[
        {
          value:0,
          label:'新数据'
        },
        {
          value:1,
          label:'历史数据'
        }],
      searchform: {
        status:0,
        datelist:[],
        orderno:null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      orderno(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.page;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    // 拼数据
    packdate(obj){
        for (let i = 0; i < obj.length; i++) {
         obj[i].produceTime =  this.$parseTime(obj[i].produceTime);
         obj[i].ordernokids = (obj[i].purchaseOrder || "" ) + (obj[i].batchno || " ")
         obj[i].factory = (obj[i].factoryCode || "" ) + (obj[i].factory_name || " ")
         obj[i].workshop = (obj[i].workshopCode || "" ) + (obj[i].workshop_name || " ")
         obj[i].workline = (obj[i].worklineCode || "" ) + (obj[i].workline_name || " ")
         obj[i].product = (obj[i].productCode || "" ) + (obj[i].product_name || " ")
        }
    },
    //搜索事件
    search() {
        this.Tabledata({
          status:this.searchform.status,
        orderno:this.searchform.orderno,
        sproduceTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        eproduceTime: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
         status:this.searchform.status,
        orderno:this.searchform.orderno,
        sproduceTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        eproduceTime: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize,
        currPage:this.searchform.currPage,
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
            //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        status:this.searchform.status,
        batchno:this.searchform.batchno,
        orderno:this.searchform.orderno,
        sproduceTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        eproduceTime: this.searchform.datelist==null ? null:this.searchform.datelist[1],
      };
      orderno(obj).then(response => {
        this.packdate(response.data.list)
        this.tableDataDownload = response.data.list;
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "订单",
            "批次号",
            "工厂",
            "车间",
            "产线",
            "产品",
            "计量单位",
            "计划生产数量",
            "采集上传数量",
            "生产日期",
          ];
          const filterVal = [
            "orderno",
            "batchno",
            "factory",
            "workshop",
            "workline",
            "product",
            "productUnit",
            "productQuantity",
            "collectionQuantity",
            "produceTime",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>